import React, { useState } from "react";
import { Input, Space } from "antd";
import { DownOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { MobileDatePicker } from "../MobilePicker/MobileDatePicker";

interface BirthDateInputProps {
  /**
   * 出生日期值 (YYYY-MM-DD 格式)
   */
  value?: string;
  /**
   * 出生日期变化回调
   */
  onChange?: (dateString: string) => void;
  /**
   * 是否只读
   */
  readOnly?: boolean;
  /**
   * 占位符文本
   */
  placeholder?: string;
  /**
   * 最大日期 (YYYY-MM-DD 格式)，用于限制可选择的最晚日期
   */
  maxDate?: string;
}

/**
 * 出生日期输入组件
 * 专用于输入出生日期，自动显示年龄
 */
export const BirthDateInput: React.FC<BirthDateInputProps> = ({ value, onChange, readOnly = false, placeholder = "請選擇", maxDate }) => {
  const [pickerVisible, setPickerVisible] = useState(false);

  // 计算年龄
  const getAge = () => {
    if (!value) return null;
    return dayjs().diff(dayjs(value), "year");
  };

  // 格式化日期显示
  const getFormattedDate = () => {
    if (!value) return null;
    return dayjs(value).format("YYYY-MM-DD");
  };

  const handleDateChange = (dateString: string) => {
    onChange?.(dateString);
  };

  const handleInputClick = () => {
    if (!readOnly) {
      setPickerVisible(true);
    }
  };

  const age = getAge();
  const formattedDate = getFormattedDate();

  return (
    <>
      <Space.Compact style={{ width: "100%" }}>
        <Input
          placeholder={placeholder}
          value={formattedDate || ""}
          onClick={handleInputClick}
          readOnly
          disabled={readOnly}
          suffix={!readOnly && <DownOutlined style={{ color: "var(--placeholder-color)", fontSize: 12 }} />}
          style={{
            cursor: readOnly ? "not-allowed" : "pointer",
          }}
        />
        {formattedDate && (
          <Space.Addon
            style={{
              minWidth: 70,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#333",
              fontSize: 16,
              fontWeight: 500,
              whiteSpace: "nowrap",
            }}
          >
            {age}&nbsp;歲
          </Space.Addon>
        )}
      </Space.Compact>

      <MobileDatePicker
        visible={pickerVisible}
        onClose={() => setPickerVisible(false)}
        title="出生日期"
        value={value}
        onChange={(dateString) => {
          handleDateChange(dateString);
          setPickerVisible(false);
        }}
      />
    </>
  );
};
